export default __webpack_public_path__ + "static/media/wallet.51a6c7fb.svg";